module.exports = __webpack_public_path__ + "media/images/sp/accessories/dress/dress_03-e8875eedc0b74b7d14a59382883c82d3.jpg";